enum RestaurantType {
  Restaurant = 1,
  WalkIn = 2,
  Bar = 3,
  CafeBakery = 4,
}

export default RestaurantType;
